import styles from "./PackageCard.module.css";

interface Package {
    name: string;
    price: number;
    gender: string;
    duration: string;
}

interface PackageCardProps {
    center: string;
    packages: Package[];
    onSelect?: (packageName: string) => void;
    selectedPackage?: string | null;
}

const formatPrice = (price: number) => {
    return new Intl.NumberFormat("en-IN", { style: "currency", currency: "INR", maximumFractionDigits: 0 }).format(price);
};

const genderLabel = (gender: string | null | undefined) => {
    if (!gender) return "All";
    switch (gender.toUpperCase()) {
        case "M": return "Male";
        case "F": return "Female";
        case "PB": return "All";
        default: return gender;
    }
};

export const PackageCard = ({ center, packages, onSelect, selectedPackage }: PackageCardProps) => {
    if (!packages || packages.length === 0) {
        return (
            <div className={styles.container}>
                <div className={styles.header}>Packages at {center}</div>
                <div className={styles.empty}>No packages available.</div>
            </div>
        );
    }

    return (
        <div className={styles.container}>
            <div className={styles.header}>Packages at {center}</div>
            <div className={styles.list}>
                {packages.map((pkg) => (
                    <button
                        key={pkg.name}
                        className={`${styles.card}${selectedPackage === pkg.name ? ` ${styles.cardSelected}` : ""}`}
                        onClick={() => onSelect?.(pkg.name)}
                    >
                        <span className={styles.name}>{pkg.name}</span>
                        <div className={styles.details}>
                            <span className={styles.price}>{formatPrice(pkg.price)}</span>
                            {pkg.duration && (
                                <>
                                    <span className={styles.separator}>·</span>
                                    <span className={styles.duration}>{pkg.duration}</span>
                                </>
                            )}
                            <span className={styles.separator}>·</span>
                            <span className={styles.gender}>{genderLabel(pkg.gender)}</span>
                        </div>
                    </button>
                ))}
            </div>
        </div>
    );
};
